<template>
    <SuperLink 
        class="main-noticies__bottom" 
        target="_self"
        :href="item.link">
        <div class="noticies-item--image" >
            <img 
                v-if="item.image"
                :src="utils.image(item.image, 160, 104)" />
            <img 
                v-else-if="item.link.image"
                :src="utils.image(item.link.image, 160, 104)" />
        </div>
        <p class="noticies__label">
            <strong v-if="item.hat">{{ item.hat }}</strong>
            <strong v-else-if="item.link && item.link.editorial">{{ item.link.editorial.title }}</strong>
        </p>
        <p class="noticies__title noticies__title--blue"><strong>{{item.title}}</strong></p>
    </SuperLink>
</template>

<script>
import utils from '@/utils'

import SuperLink from '@/components/SuperLink'

export default {
    name: 'Small',
    props:['item'],
    components:{SuperLink},
    data(){
        return {
            utils:utils
        }
    }
}
</script>